/**
 * DENET — LED dönüşüm tasarrufu
 *
 * Aydınlatmada satış argümanı fiyat değil geri dönüş süresi. "Bu armatür
 * 1.400 lira" cümlesi pahalı; "dokuz ayda kendini ödüyor" cümlesi yatırım.
 *
 * Hesap kasten sade: elektrik faturasındaki tasarruf. Bakım, lamba değişim
 * maliyeti ve ışık kalitesi kazancı dahil değil — onları da katsak sayı
 * büyür ama doğrulanamaz hâle gelir.
 */

import { DenetElement, define, qsa } from '@denet/core';

const nf = new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 0 });
const nf1 = new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 1 });

class DnSaving extends DenetElement {
  mounted() {
    qsa('input, select', this).forEach((f) => {
      f.addEventListener('input', () => this.#run(), { signal: this.signal });
    });
    this.#run();
  }

  #run() {
    const val = (r) => Number(this.ref(r)?.value) || 0;
    const out = (r, t) => { const el = this.querySelector(`[data-out="${r}"]`); if (el) el.textContent = t; };

    qsa('[data-echo]', this).forEach((el) => {
      const src = this.ref(el.dataset.echo);
      if (src) el.textContent = nf.format(Number(src.value));
    });

    const count = val('count');
    const oldW = val('oldWatt');
    const newW = val('newWatt');
    const hours = val('hours');
    const days = val('days');
    const price = val('price');
    const unit = val('unitPrice');

    const yearlyHours = hours * days;
    const oldKwh = (count * oldW * yearlyHours) / 1000;
    const newKwh = (count * newW * yearlyHours) / 1000;
    const savedKwh = oldKwh - newKwh;
    const savedTl = savedKwh * price;

    const invest = count * unit;
    /* Geri dönüş yalnızca tasarruf pozitifse anlamlı. */
    const months = savedTl > 0 ? (invest / savedTl) * 12 : null;

    out('oldKwh', nf.format(oldKwh));
    out('newKwh', nf.format(newKwh));
    out('savedKwh', nf.format(savedKwh));
    out('savedTl', nf.format(savedTl));
    out('invest', nf.format(invest));
    out('monthly', nf.format(savedTl / 12));

    const payback = this.querySelector('[data-out="payback"]');
    const note = this.querySelector('[data-ref="paybackNote"]');
    if (payback) {
      if (months === null) {
        payback.textContent = '—';
        if (note) note.textContent = this.dataset.noSaving || 'Yeni armatür daha çok tüketiyor.';
      } else if (months > 120) {
        payback.textContent = '10+';
        if (note) note.textContent = this.dataset.long || 'Geri dönüş on yılı aşıyor; değerleri gözden geçirin.';
      } else {
        payback.textContent = nf1.format(months);
        if (note) note.textContent = this.dataset.unit || 'ay';
      }
    }

    /* Tasarruf çubuğu: yeni tüketimin eskiye oranı. */
    const bar = this.querySelector('[data-ref="bar"]');
    if (bar && oldKwh > 0) {
      bar.style.width = `${Math.max(0, Math.min(100, (newKwh / oldKwh) * 100))}%`;
    }
  }
}

define('dn-saving', DnSaving);
